import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineMinus, BsPlus } from "../../shared/utils/Icons";
import { EventProps } from "../../shared/components/Filter/FilterType";
import { RootState } from "../../store";
import { productActions } from "../../store/product-slice";
import {
  StyledCategoryFIlterButton,
  StyledCategoryFilterContainer,
} from "./CategoryFilter.styles";
import {
  ApiProps,
  CategoryProps, SubCategoryProps, SubLevelCategoryProps, TopLevelCategoryProps,
} from "./CategoryFilterType";
import { TICKIMAGE } from "../../shared/utils/Images";

export const TopLevelCategory = ({
  Tick,
  category,
  setActiveKey,
  index,
  actions,
}: TopLevelCategoryProps) => {
  const dispatch = useDispatch();
  const { apiPayload } = useSelector((state: RootState) => state.productActions);
  const activeSubcategories = category
    ?.subcategory
    ?.filter((activeSubcategory:SubCategoryProps) => apiPayload
      .subCategory.includes(activeSubcategory.subcategory_id));
  return (
    <div className="top-level-category">
      <div className="tick">
        {apiPayload.category.includes(category.category_id)
          && Tick}
      </div>
      <button
        type="submit"
        id={category.category_id}
        className={
          apiPayload.category.includes(category.category_id)
            ? "active"
            : "inactive"
        }
        onClick={() => {
          dispatch(actions.category(category.category_id));
          setActiveKey(index);
          if (activeSubcategories?.length === 0
            && apiPayload.category.includes(category.category_id)) {
            dispatch(actions.removeCategoryFilter(category.category_id));
          } else if ((activeSubcategories?.length > 0
            && apiPayload.category.includes(category.category_id))) {
            dispatch(actions.category(category.category_id));
          } else {
            dispatch(actions.category(category.category_id));
          }
        }}
      >
        {category.display_name}
        { activeSubcategories?.length > 0 && (
        <span className="count">
          (
          {activeSubcategories?.length}
          )
        </span>
        )}
      </button>
    </div>
  );
};

export const SubLevelCategory = ({
  Tick,
  subcategory,
  category,
  actions,
  api,
}: SubLevelCategoryProps) => {
  const dispatch = useDispatch();
  const { apiPayload } = useSelector((state: RootState) => state.productActions);
  return (
    <div className="sub-level-category">
      <div className="sub-tick">
        {apiPayload.subCategory.includes(subcategory.subcategory_id)
          && apiPayload.category.includes(category.category_id)
          && Tick}
      </div>
      <button
        type="submit"
        id={subcategory.subcategory_id}
        className={
          apiPayload.subCategory.includes(subcategory.subcategory_id)
            ? "active"
            : "inactive"
        }
        onClick={() => {
          if (api.subCategory.includes(subcategory.subcategory_id)) {
            dispatch(actions.removeSubCategoryFilter(subcategory.subcategory_id));
          } else {
            dispatch(actions.subCategory(subcategory.subcategory_id));
          }
        }}
      >
        {subcategory.display_name}
      </button>
    </div>
  );
};
const CategoryFilter = () => {
  const dispatch = useDispatch();
  const { categories } = useSelector((state: RootState) => state.category);
  const { apiPayload } : ApiProps | any = useSelector((state: RootState) => state.productActions);
  const actions: Record<string, ActionCreatorWithPayload<any, string>> = {
    category: productActions.categoryFilter,
    subCategory: productActions.subcategoryFilter,
    removeSubCategoryFilter: productActions.removeSubCategoryFilter,
    removeCategoryFilter: productActions.removeCategoryFilter,
  };
  const Tick = <img src={TICKIMAGE} className="tick" alt="tick" />;
  const [activeKey, setActiveKey] = useState(null);
  const [open, setOpen] = useState(false);
  const categoryFilterRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.addEventListener("click", (event: EventProps) => {
      if (!categoryFilterRef.current?.contains(event.target)) {
        setOpen(false);
      }
    });
  });
  return (
    <StyledCategoryFilterContainer data-testid="category-filter" ref={categoryFilterRef}>
      <StyledCategoryFIlterButton
        data-testid="category-button"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <div className="filter-head">
          <div className="subheading" data-testid="category">Category</div>
          <div className="applied-filter-account">
            { apiPayload.subCategory.length > 0 && (
            <span>
              (
              {apiPayload.subCategory.length}
              )
            </span>
            )}
          </div>
        </div>
        <BsPlus data-testid="add" className={!open ? "add" : "add-inactive"} />
        {open && <AiOutlineMinus data-testid="sub" className="sub" />}
      </StyledCategoryFIlterButton>

      {open && (
        <div className="category-dropdown" data-testid="category-dropdown">
          <div className="head">
            <div className="head-tick">
              {apiPayload.category.length === 0
                && apiPayload.subCategory.length === 0
                && Tick}
            </div>
            <button
              type="submit"
              className="all-categories"
              data-testid="all-categories"
              onClick={() => {
                dispatch(productActions.emptyFilter());
              }}
            >
              All Categories
            </button>
          </div>
          {categories.map((category: CategoryProps, index) => {
            return (
              <div className="category-container">
                <TopLevelCategory
                  isActive={activeKey === index}
                  index={index}
                  actions={actions}
                  category={category}
                  Tick={Tick}
                  setActiveKey={setActiveKey}
                />
                { (activeKey === index) && apiPayload.category.includes(category.category_id) && (
                  <div>
                    {category.subcategory.map(
                      (subcategory: SubCategoryProps) => {
                        return (
                          <SubLevelCategory
                            actions={actions}
                            category={category}
                            subcategory={subcategory}
                            Tick={Tick}
                            api={apiPayload}
                          />
                        );
                      },
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </StyledCategoryFilterContainer>
  );
};

export default CategoryFilter;
